<template>
  <v-container class="pa-0">
    <div v-if="loading">
      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-center align-center"
          style="height: 100vh;"
        >
          <v-progress-circular
            indeterminate
            size="64"
            color="#2661FF"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12" md="6">
          <h2 class="title text_color">
            ETLS
          </h2>
        </v-col>
      </v-row>
      <!------------------------------------------>
      <!-- STATUS -------------------------------->
      <!------------------------------------------>
      <v-row>
        <v-col cols="12">
          <v-card class="custom_card" elevation="0">
            <v-card-title class="text_color">
              Carte server status
            </v-card-title>
            <v-card-text>
              <v-alert :type="alertType" outlined class="rounded-lg">
                <span class="body-2 text_color">
                  El servidor de carte se encuentra en estado:
                  <strong>{{ serverStatusText }}</strong>
                </span>
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <ExecuteJobs />
        </v-col>
        <v-col cols="12">
          <ExecuteTransformations />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { etlsService } from '../../services/etls.service'
import ExecuteTransformations from '../../components/ETLS/ExecuteTransformations.vue'
import ExecuteJobs from '../../components/ETLS/ExecuteJobs.vue'

export default {
  name: 'ETLS',
  components: { ExecuteTransformations, ExecuteJobs },
  data () {
    return {
      loading: false,
      serverStatus: false,
      valid: false,
      submitLoading: false,
      database: null,
      databases: ['analytics', 'staging'],
      files: []
    }
  },
  async mounted () {
    await this.checkServerStatus()
  },
  computed: {
    serverStatusText () {
      return this.serverStatus ? 'Activo' : 'Inactivo'
    },
    alertType () {
      return this.serverStatus ? 'success' : 'error'
    }
  },
  methods: {
    async checkServerStatus () {
      this.loading = true
      try {
        await etlsService.checkServerStatus()
        this.serverStatus = true
      } catch (error) {
        Vue.noty.error('Ocurrió un error al obtener el estado del servidor')
        this.serverStatus = false
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #344054 !important;
}
</style>
